import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, nothing, TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-about-me-slice.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import '../../base/outline-container/outline-container';

/**
 *
 * @elementsList - this is a list of all elements and attributes, surveyed from Figma.
 * -title - always present, string.
 * -left column - always present, headings and text.
 * -right column - always present, headings, text and tables.

 *
 * @orderedElementsList - this is a list of all elements, with their order pieced together, from Figma.
 * background
 *    title
 *    left column
 *      heading
 *      text
 *      table
 *    right column
 *      heading
 *      text
 *      table
 *
 */

/**
 * The GHS About Me Slice component
 * @element ghs-about-me-slice
 * @slot - aboutMeTitle, title of the slice.
 * @slot - aboutMeLeftColumnSlot - left side of the slice.
 * @slot - aboutMeRightColumnSlot - right side of the slice.
 */
@customElement('ghs-about-me-slice')
export class GhsAboutMeSlice extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  @state() hasTitleSlot: boolean;
  @state() hasLeftColSlot: boolean;
  @state() hasRightColSlot: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasTitleSlot = this.slots.test('about-me-title');
    this.hasLeftColSlot = this.slots.test('about-me-left-column');
    this.hasRightColSlot = this.slots.test('about-me-right-column');
  }

  render(): TemplateResult {
    const classes = {
      'about-me-slice': true,
      'w-full': true,
    };

    return html` <div class="${classMap(classes)}">
      <div class="about-me-background">
        <outline-container x-padding container-align="center">
          ${this.hasTitleSlot
            ? html`
                <ghs-heading
                  level="h3"
                  level-size="4xl"
                  level-style="bold"
                  class="about-me-title"
                  site=${this.site}
                >
                  <slot name="about-me-title"></slot>
                </ghs-heading>
              `
            : nothing}
          <div class="about-me-content-section">
            <div class="about-me-left-column">
              ${this.hasLeftColSlot
                ? html`<slot name="about-me-left-column"></slot> `
                : nothing}
            </div>
            <div class="about-me-right-column">
              ${this.hasRightColSlot
                ? html`<slot name="about-me-right-column"></slot>`
                : nothing}
            </div>
          </div>
        </outline-container>
      </div>
    </div>`;
  }
}
